import React from "react";
import { CourseItem } from "service/service";
import { getCoursePlanWeek } from "service/course";
import { atomFamily } from "jotai/utils";
import { atom } from "jotai";

interface CourseContextProps {
    course: CourseItem;
    basename: string;
    path: string;
    updateCourses: () => Promise<void>;
}

export const CourseContext = React.createContext<CourseContextProps>({
    course: {} as CourseItem,
    basename: "",
    path: "",
    updateCourses: () => Promise.resolve()
});

export const CoursePlanAtom = atomFamily(
    ({ courseNo, courseSeq }: { courseNo: string; courseSeq: string }) => {
        return atom(get => {
            return getCoursePlanWeek({ courseNo, courseSeq });
        });
    },
    (arg1, arg2) => {
        return (
            arg1.courseNo === arg2.courseNo && arg1.courseSeq === arg2.courseSeq
        );
    }
);
